<footer class="bg-[#0A3D2F] text-white/80 border-t border-white/5 font-['Source_Sans_3']">
  <div class="max-w-7xl mx-auto px-6">


    <!-- Copyright -->
    <div class="py-4 border-t border-white/5 flex flex-col md:flex-col justify-between items-center gap-2 text-xs font-medium text-white/40 uppercase tracking-widest">
      <p>&copy; {{ currentYear }} ALL NIGERIA COMMUNITY GHANA. ALL RIGHTS RESERVED.</p>
      <div class="flex gap-6">
        <span>Powered by DrayTech IT Solutions</span>
      </div>
    </div>
  </div>
</footer>
